import { Theme } from '@mui/material';

export default {
  components: {
    styleOverrides: {
      root: ({ theme }: { theme: Theme }) => ({
        '&.dropdown': {
          backgroundColor: theme.palette.secondary.main,
          borderRadius: 8
        }
      })
    }
  }
};
